import request from '@/utils/request'

export default {
  // 获取当前登录用户信息
  getCurIoUserInfo() {
    return request({
      url: '/sysUser/getCurIoUserInfo',
      method: 'get'
    })
  }
}
